import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@material-ui/icons/Delete";
import { colors, IconButton, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useStylesAutoSafe, useStylesLbl } from "../../../../St/Reports/UseStyle";
import { useStylesTF } from "../../../../St/comps/UseStyle";

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
        minHeight: 400

    },
}));

export default function SarfTwreedTable(props) {
    const { paramsSubList,
        rptParams,
        valueAutosSub,
        setValueAutosSub,
        unitsOptions, setParamsSubList, estelamAfter, selectRow, permissions
    } = props;


    const stylH = {
        // borderWidth: 1,
        border: "solid 0.6px",
        borderColor: "black",
        borderStyle: "solid",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 16,
        color: "#fff"
    }
    const stylRo = {
        BorderBottom: "solid 0.5px",
        //borderStyle: "solid",
        borderColor: "gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#000"
    }
    const onRowDelete = async (rowdata) => {
        var newData = paramsSubList.filter((obj) => obj.barcode.toString() !== rowdata.barcode.toString());
        setParamsSubList([...newData]);
    }
    const onRowClick = async (rowdata) => {
        selectRow(rowdata);
    }
    const [rowItem, setRowItem] = useState({});
    const clasTF = useStylesTF();
    const claslbls = useStylesLbl();
    const clasSaf = useStylesAutoSafe();
    const claslbl = useStylesLbl();
    const handleOpenUpdate = (props, e, row) => {
        var newDataVal = paramsSubList.filter((obj) => obj.editVal === true);
        var newDataPrice = paramsSubList.filter((obj) => obj.editPrice === true);
        var newDataUnit = paramsSubList.filter((obj) => obj.editUnit === true);
        console.log("the rowItem data inve is", rowItem);

        if (rowItem?.no != null) {
            if (rowItem.no == row.no) {
                if (newDataVal.length != 0 && props !== "editVal") {
                    EnterChangeTtems("quan", rowItem, row);
                } else if (newDataPrice.length != 0 && props !== "editPrice") {
                    EnterChangeTtems("price", rowItem, row);
                }
                else if (newDataUnit.length != 0 && props !== "editUnit") {
                    EnterChangeTtems("quan", rowItem, row);
                    setRowItem({});
                }
            } else {
                if (newDataVal.length != 0 && props !== "editVal") {
                    EnterChangeTtems("quan", rowItem, row);
                } else if (newDataPrice.length != 0 && props !== "editPrice") {
                    EnterChangeTtems("price", rowItem, row);
                }
                else if (newDataUnit.length != 0 && props !== "editUnit") {
                    EnterChangeTtems("quan", rowItem, row);
                    setRowItem({});
                }
            }
        } else {
            if (props === "editVal") {

                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...paramsSubList];
                dataUpdate[index] = {
                    ...row,
                    editVal: true,
                };
                setParamsSubList([...dataUpdate]);

            } else if (props === "editPrice") {
                e.preventDefault();
                setRowItem({ ...row });
                const index = row?.no;
                const dataUpdate = [...paramsSubList];
                dataUpdate[index] = {
                    ...row,
                    editPrice: true,
                };
                setParamsSubList([...dataUpdate]);
            }
            else if (props === "editUnit") {
                if (row?.Units?.length > 1) {
                    e.preventDefault();
                    setRowItem({ ...row });
                    const index = row?.no;
                    const dataUpdate = [...paramsSubList];
                    dataUpdate[index] = {
                        ...row,
                        editUnit: true,
                    };
                    setParamsSubList([...dataUpdate]);
                }
            }
        }

    };

    const changAutoCurrUnits = (row, newValue) => {

        let prc = rptParams.Type_Cost == 1 ? newValue.sale : newValue.purch;

        let quantot = 0.0;
        let pricee = 0.0;
        let sumPrc = 0.0;
        let AllQun = 0.0;
        sumPrc = rptParams.Type_Cost == 1 ? parseFloat(newValue.sale) : parseFloat(newValue.purch);
        quantot = (parseFloat(row.quan) * parseFloat(newValue.perc)).toFixed(2);
        sumPrc = (parseFloat(row.quan) * parseFloat(sumPrc)).toFixed(2);
        AllQun = (parseFloat(row.qty_balance) / parseFloat(newValue.perc)).toFixed(2);
        const index = rowItem?.no;
        const dataUpdate = [...paramsSubList];
        dataUpdate[index] = {
            ...rowItem,
            unit: newValue.unit,
            perc: newValue.perc,
            price: pricee,
            cost_curr: newValue.purch,
            Cost: newValue.purch,
            sum: sumPrc,
            totquan: quantot,
            purchPrice: newValue.purch,
            salePrice: newValue.sale,
            unitName: newValue.unitName,
            unit_balance: AllQun,
            editUnit: false,
        };
        setParamsSubList([...dataUpdate]);
        setRowItem({});
    };
    const { t } = useTranslation(["forms"]);

    const classes = useStyles();

    const MathChangIdataTtems = (prop, row) => (event) => {
        let i = {
            res: Number(event.target.value),
            quan: Number(row.quan),
            perc: Number(row.perc),
            totquan: Number(row.totquan),
            price: Number(row.price),
            sum: Number(row.sum),
        };
        if (prop === "quan") {


            i.sum = i.res * i.price;
            i.totquan = i.perc * i.res;
            setRowItem({
                ...rowItem,
                [prop]: event.target.value,
                sum: i.sum,
                totquan: i.totquan,
            });
        } else if (prop === "price") {

            i.sum = i.res * i.quan;
            i.totquan = i.perc * i.quan;

            setRowItem({
                ...rowItem,
                [prop]: event.target.value,
                sum: i.sum,
                totquan: i.totquan,
            });
        }
    };

    const EnterChangeTtems = (prop, rowItem, row) => {
        let i = {
            quan: Number(rowItem.quan),
            totquan: Number(rowItem.totquan),
            price: Number(rowItem.price),
            sum: Number(rowItem.sum),
        };

        if (prop === "quan") {
            const index = row?.no;
            const dataUpdate = [...paramsSubList];
            dataUpdate[index] = {
                ...rowItem,
                quan: i.quan,
                totquan: i.totquan,
                price: i.price,
                sum: i.sum,
                editVal: false,
            };
            setParamsSubList([...dataUpdate]);
            setRowItem({});
        }

        if (prop === "price") {
            const index = row?.no;
            const dataUpdate = [...paramsSubList];
            dataUpdate[index] = {
                ...rowItem,
                quan: i.quan,
                totquan: i.totquan,
                price: i.price,
                sum: i.sum,
                editPrice: false,
            };
            setParamsSubList([...dataUpdate]);
            setRowItem({});
        }

    };



    return (
        <TableContainer component={Paper} >
            <Table
                //className={classes.table} 
                size="small" aria-label="a dense table" >
                <TableHead>
                    <TableRow
                        style={{
                            backgroundColor: "#3f51b5",
                            color: "#000",
                            fontWeight: 800,
                            fontFamily: "Amiri-Regular",
                            fontSize: 17,
                            border: "solid 0.6px"
                        }}
                    >
                        <TableCell style={stylH} hidden={true} align="center">
                            {"الرقم"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {" الباركود"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"الصنف"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"الوحدة"}
                        </TableCell>

                        <TableCell style={stylH} align="center">
                            {"الكمية"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"الكمية الاجمالية"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"السعر"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"الاجمالي"}
                        </TableCell>
                        <TableCell style={stylH} align="center">
                            {"Action"}
                        </TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {paramsSubList.map((row) => (
                        <TableRow key={row.barcode}
                            style={{
                                padding: "5px 0px",
                                textAlign: "-webkit-center",
                                margin: "0px",
                                whiteSpace: "nowrap",
                                color: "#000",
                                fontWeight: 800,
                                fontFamily: "Amiri-Regular",
                                fontSize: 17,
                                border: "solid 0.6px"
                            }}>
                            <TableCell style={stylRo} align="center" >{row.no + 1}</TableCell>
                            <TableCell style={stylRo} align="center" >{row.barcode}</TableCell>

                            <TableCell style={stylRo} align="center" >{row.symbol}</TableCell>

                            <TableCell style={stylRo} align="center" onDoubleClick={(event) => handleOpenUpdate("editUnit", event, row)}
                            >
                                {
                                    row?.editUnit && row?.Units?.length > 1 ? (
                                        <Autocomplete
                                            autoHighlight
                                            openOnFocus
                                            classes={clasSaf}
                                            value={row.defUnit}
                                            onChange={(event, newValue) => {
                                                changAutoCurrUnits(row, newValue);
                                            }}
                                            id="combo-box-demo"
                                            options={row?.UnitsTable}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option.unitName
                                            }
                                            // onBlur={(e) => EnterChangeTtems("val1", rowItem, row)}
                                            disableClearable
                                            style={{ backgroundColor: colors.green[50] }}
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label={"الوحدة"}
                                                    variant="outlined"
                                                    InputLabelProps={{ className: claslbls.clrBlackLblS }}
                                                />
                                            )}

                                        />
                                    ) :
                                        (
                                            row.unitName
                                        )

                                }
                            </TableCell>
                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editVal", event, row)}
                            >
                                {
                                    row.editVal ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="quan"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="number"
                                                    name="quan"
                                                    onBlur={(e) => EnterChangeTtems("quan", rowItem, row)}
                                                    value={rowItem.quan}
                                                    onChange={MathChangIdataTtems("quan", row)}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("quan", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("quan", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row.quan)?.toFixed(2)
                                        )}
                            </TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row?.totquan).toFixed(2)}</TableCell>

                            <TableCell style={stylRo} align="center"
                                onDoubleClick={(event) => handleOpenUpdate("editPrice", event, row)}
                            >
                                {
                                    row.editPrice ?
                                        (
                                            <>
                                                <TextField fullWidth
                                                    variant="outlined" size="small"
                                                    id="quan"
                                                    className={clasTF.rootSafe}
                                                    style={{ backgroundColor: colors.grey[50] }}
                                                    type="number"
                                                    name="price"
                                                    onBlur={(e) => EnterChangeTtems("price", rowItem, row)}
                                                    value={rowItem.price}
                                                    onChange={MathChangIdataTtems("price", row)}
                                                    InputProps={{
                                                        className: claslbl.clrSafe,
                                                        onKeyDown: (event) => {
                                                            if (event.key === 'Enter') {
                                                                EnterChangeTtems("price", rowItem, row);
                                                            }
                                                        },
                                                        onBlur: () => {
                                                            EnterChangeTtems("price", rowItem, row);
                                                        },
                                                    }}
                                                />

                                            </>

                                        ) : (
                                            parseFloat(row.price)?.toFixed(2)
                                        )}
                            </TableCell>
                            <TableCell style={stylRo} align="center" >{parseFloat(row?.sum).toFixed(2)}</TableCell>

                            <TableCell style={stylRo} align="center" >
                                <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    style={{ maxHeight: "0.7rem" }}
                                    // onClick={onDelete}

                                    onClick={() => {
                                        onRowDelete(row);
                                    }}>

                                    <DeleteIcon size={"small"} />
                                </IconButton>
                            </TableCell>

                        </TableRow>
                    ))}
                </TableBody>

            </Table>

        </TableContainer>

    );
}
